import { useState, useRef, useEffect } from 'react';
import {Container,Row,Col} from 'react-bootstrap';
import { Dialog } from 'primereact/dialog';
import { Pregunta } from './pregunta';
import Confeti from '../confeti';
import Lluvia from '../lluvia';
import { Toast } from 'primereact/toast';
import api from '../../interceptor/axios';

const restUrlBase = process.env.REACT_APP_REST_URL;




export const Corrector = ({ preguntas: preguntasProp, puntuacion, correctas, erroneas, enBlanco, metodoCorreccion, esTestGuardado, permiteImpugnar }) => {   
    const [preguntas, setPreguntas] = useState(preguntasProp);
    const [mostrarNota, setMostrarNota] = useState(!esTestGuardado);
    const [nota, setNota] = useState(puntuacion || 0);
    const [numCorrectas, setNumCorrectas] = useState(correctas || 0);
    const [numErroneas, setNumErroneas] = useState(erroneas || 0);
    const [numEnBlanco, setNumEnBlanco] = useState(enBlanco || 0);

    const ocultarNota = () => {
      setMostrarNota(false); 
    };
    const toast = useRef(null);

    const marcarFavorita = (id, favorita) => {
        api.post(restUrlBase + "test/preguntaFavorita.php", { idPregunta: id, favorita: favorita }).then(response => {
                if (response.data.success == false) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se ha producido un error en la llamada al servidor' });
                } else {
                    if(favorita == 'S'){
                        toast.current.show({ severity: 'success', summary: 'Pregunta añadida a favoritas', detail: '' });
                    } else {
                        toast.current.show({ severity: 'success', summary: 'Pregunta eliminada de favoritas', detail: '' });
                    }
                    
                    const newPreguntas = [...preguntas];
                    const idx = newPreguntas.findIndex(p => p.ID === id);
                    if (idx !== -1) {
                        newPreguntas[idx] = { ...newPreguntas[idx], favorita: (favorita === 'S' ? 1 : 0) };
                        setPreguntas(newPreguntas);
                    }
                }            
            }).catch(error => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se ha producido un error en la llamada al servidor' });
            }
         );
    };

    useEffect(() => {
        if(esTestGuardado) {
            let preguntasCorrectas = 0;
            let preguntasErroneas = 0;
            let preguntasNoContestadas = 0;

            const newPreguntas = [...preguntas];
            for(let index = 0; index < newPreguntas.length; index++){
                if(newPreguntas[index].respuestaCorrecta == newPreguntas[index].respuestaSeleccionada){
                    preguntasCorrectas++;
                    newPreguntas[index].estado = 'correcta';
                } else if(newPreguntas[index].respuestaSeleccionada != 0) {
                    preguntasErroneas++;
                    newPreguntas[index].estado = 'erronea';
                } else {
                    preguntasNoContestadas++;
                    newPreguntas[index].estado = 'no-contestada';
                }
            }

            correctas = preguntasCorrectas;
            erroneas = preguntasErroneas;
            enBlanco = preguntasNoContestadas;

            let penalizacion = 2;
            if(metodoCorreccion == "2-1"){
                penalizacion = 2;
            } else if(metodoCorreccion == "3-1"){
                penalizacion = 3;
            } else if(metodoCorreccion == "4-1"){
                penalizacion = 4;
            }
            puntuacion = (preguntasCorrectas - (preguntasErroneas / penalizacion)) / newPreguntas.length * 10;
            if(puntuacion < 0){
                puntuacion = 0;
            }
            puntuacion = Math.round((puntuacion + Number.EPSILON) * 100) / 100;

            setPreguntas(newPreguntas);
            setNumCorrectas(correctas);
            setNumErroneas(erroneas);
            setNumEnBlanco(enBlanco);
            setNota(puntuacion);
        }
    }, [esTestGuardado, preguntasProp, metodoCorreccion]);

    return (
        <>
        <Toast ref={toast} />
        <Dialog showHeader={false} visible={mostrarNota && puntuacion < 5} onHide={() => ocultarNota} className='modal-nota'>
            <Lluvia nota={nota} onClose={() => setMostrarNota(false)} correctas={correctas} erroneas={erroneas} enBlanco={enBlanco} metodoCorreccion={metodoCorreccion} />
        </Dialog>

        <Dialog showHeader={false} visible={mostrarNota && puntuacion >= 5} className='modal-nota-confeti'>
            <Confeti nota={nota} onClose={() => setMostrarNota(false) } correctas={correctas} erroneas={erroneas} enBlanco={enBlanco} metodoCorreccion={metodoCorreccion} />
        </Dialog>
            
    
        <div>
            <h2>Nota: {nota}</h2>
            <ul>
                <li>Fórmula de corrección: {metodoCorreccion}</li>
                <li>Correctas: {numCorrectas}</li>
                <li>Erróneas: {numErroneas}</li>
                <li>En blanco: {numEnBlanco}</li>
            </ul>
        </div>
        <div className='w-100'>
            {preguntas.map((pregunta, index) => { 
                return (
                    <Pregunta key={index} pregunta={pregunta} respuestaMarcada={pregunta.respuestaSeleccionada} notifyCambioRespuesta={() => {}} notifyFavoritos={marcarFavorita} modoAyudaActivado={true} permiteImpugnar={permiteImpugnar} />
                );
            })}
        </div>                     
        </>
    );
};

export default Corrector;
